import { lazy } from 'react';
import withSuspense from '../../helpers/withSuspense.jsx';
import OptionGridSkeleton from './OptionGridSkeleton.jsx';

const OptionGrid = withSuspense(lazy(() => import('./OptionGrid.jsx')), OptionGridSkeleton)

export default OptionGrid;
